import moment from "moment";

/**
 * Normalizes a timestamp string to ensure it's treated as UTC if no timezone is provided.
 * This prevents the browser from incorrectly interpreting UTC strings as local time.
 */
export const normalizeTimestamp = (timestamp: string | Date | undefined): Date => {
	if (!timestamp) return new Date();

	if (timestamp instanceof Date) return timestamp;

	// If it's a string and doesn't have a timezone indicator (Z or +/-), append Z
	let normalized = timestamp;
	if (typeof normalized === 'string' &&
		!normalized.endsWith('Z') &&
		!normalized.includes('+') &&
		!normalized.match(/-\d{2}:\d{2}$/)) {
		normalized = `${normalized}Z`;
	}

	const date = new Date(normalized);
	// Fallback for invalid dates
	return isNaN(date.getTime()) ? new Date() : date;
};

export const formatDate = (date: Date | undefined) => {
	if (!date) return undefined;
	return moment(date.toString()).format("MM/DD/YYYY");
};
